module.exports = __webpack_public_path__ + "media/images/flags/mo-9ef2ce6fb839177083ee7fd850b6a1db.svg";